'use client';

import { preload } from 'swr';
import { swrFetcher } from './api';

/**
 * Route → primary SWR keys to warm on menu hover.
 * Only static/predictable keys are listed — pages whose list key depends on
 * persisted filters are left out (their aux endpoints are usually shared).
 */
const ROUTE_API: Record<string, string[]> = {
  '/crm': ['/api/user/crm/dashboard', '/api/user/crm/analytics/forecast', '/api/user/crm/analytics/funnel'],
  '/crm/leads': ['/api/user/crm/leads'],
  '/crm/activities': ['/api/user/calendar/events'],
  '/contacts': ['/api/admin/obchod/contacts?size=500', '/api/admin/obchod/contact-sources', '/api/admin/obchod/contacts/tags/all'],
  '/accounts': ['/api/admin/obchod/contact-sources'],
  '/devices': ['/api/user/devices'],
  '/email': ['/api/user/email/accounts'],
  '/sms': ['/api/user/sms/devices'],
  '/chat': ['/api/user/chat/conversations'],
  '/reservations': ['/api/reservations'],
  '/consumption': ['/api/consumption'],
  '/credit': ['/api/user/credit/balance', '/api/user/stripe/products'],
  '/monitors': ['/api/user/monitors', '/api/user/monitors/events?page=0&size=5&sortBy=createdAt&sortDir=desc'],
  '/news': ['/api/user/news'],
  '/notes': ['/api/user/notes/tags'],
  '/armorik': ['/api/user/armorik/accounting/saved-filters'],
  '/armorik/periods': ['/api/user/armorik/accounting/owners?activeOnly=true'],
  '/armorik/coa-templates': ['/api/user/armorik/accounting/coa-templates'],
  '/armorik/saldo-sheets': ['/api/user/armorik/accounting/saldo-sheets'],
  '/obchod/purchase-orders': ['/api/user/obchod/purchase-orders/status-counts'],
  '/obchod/analytics': ['/api/admin/obchod/analytics/teams', '/api/admin/obchod/analytics/sales-users'],
  '/calendar': ['/api/user/calendar/users', '/api/user/calendar/teams'],
  '/tasks': ['/api/user/calendar/users', '/api/user/calendar/teams'],
  '/meetings': ['/api/user/calendar/users', '/api/user/calendar/teams'],
  '/calls': ['/api/user/calendar/users', '/api/user/calendar/teams'],
};

const PREFETCH_TTL = 60_000; // don't re-prefetch the same URL within a minute
const lastPrefetch = new Map<string, number>();

export function prefetchRoute(href: string) {
  const urls = ROUTE_API[href];
  if (!urls) return;
  const now = Date.now();
  for (const url of urls) {
    if (now - (lastPrefetch.get(url) ?? 0) < PREFETCH_TTL) continue;
    lastPrefetch.set(url, now);
    preload(url, swrFetcher);
  }
}
